import { BaseService } from "./BaseService";

export const AcaoService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('acao/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos ações:', error);
            return false;
        }
    },
    async select(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIGet('acao/select', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todas ações:', error);
            return false;
        }
    },
    async store(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('acao', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a criação de ação:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`acao/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de ação:', error);
            return false;
        }
    }, 
    async update(id, postData) {
        try {
            postData.append("_method", "PUT");
            return await BaseService.fetchResponseFromAPIPost(`acao/${id}`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a atualização de ação:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('acao/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir ação(s):', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('acao/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar ação(s):', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('acao/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar ação(s):', error);
            return false;
        }
    }, 
}